import { env } from "@/config/env";

export function isLaunchDarklyConfigured(): boolean {
  return env.launchDarklyEnabled && Boolean(env.launchDarklyClientSideId);
}
